const s = {
    defaultProps: {
        colorScheme: "cyan",
        size: "md",
    },
};
export default s;
